import {Component, Input, OnInit} from '@angular/core';
import {DocumentTypeModel} from '../../shared/dto/document-type.model';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {DocumentDetailsService} from '../../service/document-details.service';
import {DocumentPage} from '../../shared/dto/document-page';
import Swal from "sweetalert2";

@Component({
  selector: 'app-blacklist-docs-viewer',
  templateUrl: './blacklist-docs-viewer.component.html',
  styleUrls: ['./blacklist-docs-viewer.component.scss']
})
export class BlacklistDocsViewerComponent implements OnInit {

  @Input() fromParent;

  docType: DocumentTypeModel = new DocumentTypeModel();
  public loader: boolean = false;
  public safeUrl: SafeResourceUrl;
  public page:DocumentPage;
  public type: string;
  documentDetails: any = [];

  constructor(
    private documentDetailsService: DocumentDetailsService, private sanitizer: DomSanitizer,) {
  }

  ngOnInit() {
    this.docType = this.fromParent.doc;
    this.getPages();
  }

  ngOnDestroy(): void {
    this.docType = null;
  }

  transform(base64Image) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64Image);
  }

  getPages() {
    this.loader = true;
    this.documentDetailsService.getPages(this.docType).subscribe(
      (data) => {
        if (data !== null && data !== "") {
          this.page = data;
          this.page.content.forEach(element => {
            this.documentDetails.push(element);
          });
        }
        this.loader = false;
      },
      error => {
        this.loader = false;
        Swal.fire(`Internal Server Error`, error.message, "error");
      }
    );
  }

}
